<template>
  <v-container fluid>
    <span> En este apartado podrás restablecer la contraseña del miembro </span>
    {{ memberId }}
    <div class="mt-8">
      <v-radio-group
        v-model="passwordRecoverOption"
        class="recover-password-group"
        hide-details
      >
        <v-radio
          label="Cambiar manualmente la contraseña del usuario"
          value="changePasswordManual"
        />
        <v-radio
          label="Enviar enlace por correo para restablecer contraseña"
          value="sendRecoveryEmail"
        />
      </v-radio-group>
    </div>
    <div md="3">
      <v-row no-gutters>
        <v-col cols="12" v-if="passwordRecoverOption == 'changePasswordManual'">
          <v-col md="12">
            <span class="pa-0 ma-0">
              Establecer nueva contraseña para el usuario.
            </span>
          </v-col>
          <v-col sm="12" md="6">
            <v-form v-model="resetPasswordForm">
              <v-text-field
                label="Nueva contraseña del miembro"
                filled
                dense
                rounded
                v-model="newPassword"
                :type="showPass ? 'text' : 'password'"
                :rules="[...passwordRules]"
                :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showPass = !showPass"
              >
              </v-text-field>
            </v-form>
          </v-col>
        </v-col>
        <v-col sm="12" md="12">
          <v-btn
            elevation="0"
            :disabled="
              passwordRecoverOption != 'sendRecoveryEmail'
                ? !resetPasswordForm
                : false
            "
            :color="color.primaryVariant"
            class="rounded-pill text-uppercase text-bold white--text"
            @click="() => (dialogSwitch = true)"
          >
            <!-- <v-icon>
                      mdi-send
                    </v-icon> -->
            {{
              passwordRecoverOption == "changePasswordManual"
                ? "Restablecer contraseña"
                : "Enviar correo"
            }}
          </v-btn>
        </v-col>
      </v-row>
    </div>
    <personalized-dialog
      :dialog="dialogSwitch"
      @save="$_handleResetPassword()"
      @discard="() => (dialogSwitch = false)"
    >
      <template #alertName>
        <h5>
          {{ confirmationMessages[passwordRecoverOption].title }}
        </h5>
      </template>
      <template #alertContent>
        <span style="font-size: 16px; text-align: center">
          {{ confirmationMessages[passwordRecoverOption].value }}
        </span>
      </template>
    </personalized-dialog>
  </v-container>
</template>
<script>
import PersonalizedDialog from "./PersonalizedDialog.vue";
import { colors } from "@/constants/colors.js";
import { mapMutations } from "vuex/dist/vuex.common.js";
import { validations } from "@/share/validations";
export default {
  props: {
    memberId: {
      type: String,
      default: "",
    },
    memberEmail: {
      type: String,
      default: "",
    },
  },
  components: {
    PersonalizedDialog,
  },
  data() {
    return {
      passwordRecoverOption: "changePasswordManual",
      confirmationMessages: {
        changePasswordManual: {
          value:
            "Estás a punto de confirmar el restablecimiento de la contraseña. ¿Deseas continuar?",
          title: "Confirmar Restablecimiento de Contraseña",
          url: "/authentication/reset-member-password",
          response:
            "La contraseña del usuario ha sido restablecida correctamente",
        },
        sendRecoveryEmail: {
          value:
            "Estás a punto de confirmar el envío del correo para restablecer la contraseña. ¿Deseas continuar?",
          title: "Confirmar Envío de Correo",
          url: "/authentication/password-recover",
          response:
            "El enlace ha sido enviado al correo del usuario correctamente.",
        },
      },
      newPassword: "",
      resetPasswordForm: true,
      passwordRules: validations.newPasswordRule(),
      showPass: true,
      color: colors,
      dialogSwitch: false,
    };
  },
  methods: {
    ...mapMutations("notification", ["show"]),
    ...mapMutations("loader", ["loading", "loaded"]),
    async $_handleResetPassword() {
      this.loading();
      try {
        const passwordDirective =
          this.confirmationMessages[this.passwordRecoverOption];
        const payload = {
          memberId: this.memberId,
          updatedPassowrd: this.newPassword,
          email: this.memberEmail,
        };

        const response = await this.axios({
          url: passwordDirective.url,
          method: "POST",
          data: payload,
        });
        if (response.status == 200) {
          this.show({
            text: passwordDirective.response,
            color: "success",
          });
        }
      } catch (error) {
        console.log(error);
        this.show({
          text: "Hubo un error al restablecer la contraseña del usuario, por favor intenta nuevamente",
          color: "error",
        });
      } finally {
        this.newPassword = "";
        this.loaded();
      }
    },
  },
};
</script>